import BackgroundSkylineSmall from "../../images/background/BackgroundSkylineSmall";
import "../../styles/components/map/SkylineSmall.scss";

export default function SkylineSmall() {
    return (
        <div className="SkylineSmall">
            <BackgroundSkylineSmall />
        </div>        
    )
}